/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import useSnackbar from "../../../hook/use-snakbar";
import { useParams } from "react-router-dom";
import { logger } from "../../../utils/logger";
import { INDUSTRY_TYPE, ORGANIZATION_CATEGORY } from "./organization-constant";
import { useOrganizationContext } from "../../../context/organization-context";

const useOrganizationView = ()=>{
    const { orgId } = useParams();
    const [basicInformation, setBasicInformation] = useState();
    const [configurationsInformation, setConfigurationsInformation] = useState();
    const [ownershipInformation, setOwnershipInformation] = useState();
    const [allownceList, setAllownceList] = useState();
    const [loadingUi, setloadingUi] = useState(false);
    const { fetchData } = useAPIHandler();
    // const {
    //     stateList
    //   }=useOrganizationContext()

    const getBasicInformation = async ()=>{
        try {
            const res = await fetchData({
                url: `/admin/organization-basic-information/${orgId}`,
                method: "GET",
              });
              setBasicInformation(res?.data)
        } catch (error) {
            logger.log(error)
        }
    }

    function getOrganizationCategoryName(id) {
        const category = ORGANIZATION_CATEGORY.find(item => item.id === id);
        return category ? category.name : 'N/A';
      }
      function getOrganizationIndustryType(id) {
        const industryType = INDUSTRY_TYPE.find(item => item.id === id);
        return industryType ? industryType.name : 'N/A';
      }
    //   function getStateName(id) {
    //     const stateName = stateList.find(item => item.id === id);
    
    //     return stateName ? stateName?.name : 'N/A'
    //   }

    const getConfigurationsInformation = async ()=>{
        try {
            const res = await fetchData({
                url: `/admin/get-organization-benefit/${orgId}`,
                method: "GET",
              });
              setConfigurationsInformation(res?.data)
        } catch (error) {
            logger.log(error)
        }
    }

    const getOwnershipInformation = async ()=>{
        try {
            const res = await fetchData({
                url: `/admin/get-ownership/${orgId}`,
                method: "GET",
              });
              setOwnershipInformation(res?.data)
        } catch (error) {
            logger.log(error)
        }
    }

    const getAllownceInformation = async ()=>{
        try {
            const res = await fetchData({
                url: `/admin/org-allowance/${orgId}`,
                method: "GET",
              });
              
              setloadingUi(true)
              setAllownceList(res?.data)
              setloadingUi(false)
        } catch (error) {
            logger.log(error)
        }
    }

    useEffect(()=>{
        getBasicInformation(),
        getConfigurationsInformation(),
        getOwnershipInformation(),
        getAllownceInformation()
    },[])

    return {
        basicInformation,
        getOrganizationCategoryName,
        getOrganizationIndustryType,
        configurationsInformation,
        ownershipInformation,
        allownceList,
        loadingUi
        // getStateName
    }

}

export default useOrganizationView